import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../../utils/storeApp";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import CallAPI from "../../../services/apiCalls";
import { useNavigate } from "react-router-dom";
import SearchMessageStatus from "./SearchMessageStatus";
import GuideMessageStatus from "./GuideMessageStatus";
import { useReactToPrint } from "react-to-print";
import { DownloadTableExcel } from "react-export-table-to-excel";

const ListMessageStatus = () => {
  const { userToken, userSession, SetSharedObject, sharedObject, userRole } =
    useUserStore((state) => ({
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
      userSession: state.userSession,
      userRole: state.userRole,
    }));

  const isAdmin =
    userRole === "SES ADMINISTRATOR" ||
    userRole === "ADMINISTRATOR" ||
    userRole === "SYSTEMADMINISTRATOR";

  const navigate = useNavigate();
  const [rowCount] = useState(500);
  const [gridResults, setGridResults] = useState([]);
  const [processing, SetProcessing] = useState(false);
  const [fromAddress, setFromAddress] = useState([]);

  const getDefaultMessageStatus = async (email, orgId) => {
    SetProcessing(true);
    let call = "/directorySearch/GetMessageStatus";
    let d = new Date();
    d.setMonth(d.getMonth() - 1);
    let search = {
      RowCount: rowCount,
      OrganizationId: orgId,
      StartDate: d,
      EndDate: new Date(),
      MessageSource: "Sent",
      sortBy: "SentDate",
      sortDir: "SentDate",
      FromAddress: email,
    };
    let o = {
      directEmailAddress: email,
      organizationId: orgId,
    };
    SetSharedObject("CurrentFromAddress", o);
    const res = await CallAPI(call, search, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetSharedObject("previousSearch", search);
      SetSharedObject("messageStatusResultsFlag", false);
      getReport(1, res.data.data.pageItems);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  useEffect(() => {
    let obj = sharedObject.recievedMessageStatusResults;
    if (sharedObject.messageStatusResultsFlag) {
      if (obj && Object.keys(obj).length > 0) {
        getReport(1, obj);
      } else {
        setGridResults([]);
      }
    } else {
      getDirectEmails(userSession.sesuser_id);
      SetSharedObject("messageStatusResultsFlag", false);
    }
    return () => {
      SetSharedObject("messageStatusResultsFlag", false);
    };
  }, [sharedObject.recievedMessageStatusResults]);

  const getDirectEmails = async (id) => {
    SetProcessing(true);
    let call = "/directorySearch/GetUserEmailsList";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      const obj = res.data.data;
      setFromAddress(obj);
      getDefaultMessageStatus(obj[0].directEmailAddress, obj[0].organizationId);
    } else if (res.status == "SERVERERROR") {
      SetProcessing(false);
    }
  };

  const [first, setFirst] = useState(1);
  const [last, setLast] = useState(25);
  const [rows, setRows] = useState(25);
  const [count, setCount] = useState(0);
  const [refreshObj, SetRefreshObj] = useState(false);

  const onPageChange = (event) => {
    setFirst(event.first + 1);
    setRows(event.rows);
    let lastNr = event.first + 25;
    let last = lastNr > count ? count : lastNr;
    setLast(last);
    let page = event.page + 1;
    SetRefreshObj(sharedObject.messageStatusSearch);
  };

  const getReport = (page, search) => {
    for (var i = 0; i < search.length; i++) {
      if (search[i].isMDN === false) {
        search[i].messageType = "Not MDN";
      } else {
        search[i].messageType = "MDN";
      }
    }
    setGridResults(search);
  };

  const getSeverity = (product) => {
    switch (product.status) {
      case "Confirmed":
        return "success";
      case "Success":
        return "success";
      case "Accepted":
        return "success";
      case "Failed":
        return "danger";
      default:
        return null;
    }
  };
  const messageStatusTemplate = (product) => {
    let s = (
      <>
        <Tag value={product.status} severity={getSeverity(product)}></Tag>
      </>
    );
    return s;
  };
  const formatDateAccepted = (dt) => {
    if (dt.dateAccepted) {
      return new Date(dt.dateAccepted).toLocaleString("en-US", {
        hour12: false,
      });
    } else {
      return "";
    }
  };
  const formatDateConfirmed = (dt) => {
    if (dt.dateConfirmed) {
      return new Date(dt.dateConfirmed).toLocaleString("en-US", {
        hour12: false,
      });
    } else {
      return "";
    }
  };

  const formatSentDate = (dt) => {
    if (dt.dateSent) {
      return new Date(dt.dateSent).toLocaleString("en-US", { hour12: false });
    } else {
      return "";
    }
  };
  const refreshPage = async () => {
    SetProcessing(true);
    setFirst(1);
    setLast(25);
    let refreshSearch = sharedObject.previousSearch;
    let call = "/directorySearch/GetMessageStatus";
    const res = await CallAPI(call, refreshSearch, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetSharedObject("previousSearch", refreshSearch);
      getReport(1, res.data.data.pageItems);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const setSelectAddress = (e) => {
    let selectedFromAddress = JSON.parse(e.target.value);
    SetSharedObject("CurrentFromAddress", selectedFromAddress);
    getDefaultMessageStatus(
      selectedFromAddress.directEmailAddress,
      selectedFromAddress.organizationId,
    );
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  return (
    <main ref={componentRef} className="ListMessageStatus">
      <header className={isAdmin ? undefined : "sp-margin7"} role="banner">
        <div className="spacer-inline sp-margin12">
          <h4 className="title-label3">Message Status</h4>
        </div>

        <div className="mid-header-bar spacer-inline">
          <div className="spacer-inline spacer-margin6 sp-pad11">
            <label htmlFor="fromAddressSelect">From:</label>
            <div className="spacer-inline">
              <select
                id="fromAddressSelect"
                className="form-control shade-2"
                aria-label="Select sender email address"
                onChange={setSelectAddress}
              >
                {fromAddress?.map((address, index) => {
                  return (
                    <option key={index} value={JSON.stringify(address)}>
                      {address.directEmailAddress}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <button
            type="button"
            className="btn btn-outline-dark sp-margin5 btn-reports-sm"
            data-target="#MsgStatusSearchModal"
            data-toggle="modal"
            aria-label="Open message status search"
            aria-haspopup="dialog"
          >
            <i className="bi bi-search" aria-hidden="true"></i>
          </button>
          {/*Reusable tools for reports*/}
          <DownloadTableExcel
            filename="SentMessageReport"
            sheet="Reports"
            currentTableRef={componentRef.current}
          >
            <button
              type="button"
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              aria-label="Download message status report as Excel"
            >
              <i className="bi bi-download" aria-hidden="true"></i>
            </button>
          </DownloadTableExcel>
          <button
            type="button"
            className="btn btn-outline-dark sp-margin5 btn-reports-sm"
            aria-label="Refresh message status results"
            onClick={(e) => {
              if (gridResults?.length > 0) refreshPage();
            }}
          >
            <i className="bi bi-arrow-clockwise" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            className="btn btn-outline-dark sp-margin5 btn-reports-sm"
            aria-label="Print message status report"
            onClick={(e) => {
              if (gridResults?.length > 0) handlePrint();
            }}
          >
            <i className="bi bi-printer" aria-hidden="true"></i>
          </button>
          {/*End*/}
          <button
            type="button"
            className="btn btn-outline-dark sp-margin5 btn-reports-sm"
            data-target="#MsgGuideModal"
            data-toggle="modal"
            aria-label="Open message status guide"
            aria-haspopup="dialog"
          >
            <i className="bi bi-chat-square-text" aria-hidden="true"></i>
          </button>
        </div>
      </header>
      <SearchMessageStatus />
      <GuideMessageStatus />

      <section className="grid-layout" aria-label="Message status results">
        {gridResults?.length > 0 ? (
          <div ref={componentRef}>
            <DataTable
              value={gridResults}
              aria-label="Message status report"
              rows={25}
              paginator
              selectionPageOnly
              rowsPerPageOptions={[25, 50, 75]}
              tableStyle={{ minWidth: "50rem" }}
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              dataKey="Id"
              columnResizeMode="expand"
              resizableColumns
              scrollable
              sortField="dateSent"
              sortOrder={-1}
            >
              <Column
                field="dateSent"
                body={formatSentDate}
                header="Sent Date"
                className="w-md8"
                sortable
              ></Column>
              <Column
                field="sentAddress"
                header="Sent To"
                className="truncate"
                sortable
              ></Column>
              <Column
                field="messageType"
                header="Message Type"
                className="w-md9"
                sortable
              ></Column>
              <Column
                field="status"
                header="Status"
                className="w-md4"
                body={messageStatusTemplate}
                sortable
              ></Column>
              <Column
                field="dateAccepted"
                body={formatDateAccepted}
                header="Date Time Accepted"
                className="w-md8"
                sortable
              ></Column>
              <Column
                field="dateConfirmed"
                body={formatDateConfirmed}
                header="Date Time Confirmed"
                className="w-md7"
                sortable
              ></Column>
              <Column
                field="extendedStatus"
                header="Extended Status"
                className="word-set"
                sortable
              ></Column>
            </DataTable>
          </div>
        ) : (
          <div
            className="empty-grid"
            role="status"
            aria-live="polite"
            aria-atomic="true"
          >
            There are currently no search results.
          </div>
        )}
      </section>
      {processing && (
        <div
          className="loader-container"
          role="status"
          aria-live="polite"
          aria-atomic="true"
          aria-labelledby="list-messagestatus-loader"
        >
          <div className="spinner" aria-hidden="true"></div>
          <div className="loading-text" id="list-messagestatus-loader">
            {loadingText}
          </div>
        </div>
      )}
    </main>
  );
};

export default ListMessageStatus;
